import { clientApi } from '../clientApi';

export type CategoryBillingAnswer = {
    id: number;
    content: string;
};

export type CategoryBillingQuestion = {
    id: number;
    content: string;
    answers: CategoryBillingAnswer[];
};

export type CategoryDealNameTemplates = {
    deal_name: string;
    id: number;
};

export type CategoryBillingQuestionsResponse = CategoryBillingQuestion[];

export type CategoryDealNameTemplatesResponse = CategoryDealNameTemplates[];

export type CategoryRequest = {
    categoryId: number;
};

export async function fetchCategoryBillingQuestions({ categoryId }: CategoryRequest) {
    return await clientApi
        .get(`categories/${categoryId}/billing-questions/`)
        .json<CategoryBillingQuestionsResponse>();
}

export async function fetchCategoryDealNameTemplates({ categoryId }: CategoryRequest) {
    return await clientApi
        .get(`categories/${categoryId}/deal-name-templates/`)
        .json<CategoryDealNameTemplatesResponse>();
}
